import { showDialogError, showDialogSuccess} from '../sweealert2';

$(document).ready(function() {
  $('.btn-submit-ordered-item').on('click', function(event){
    let isDeliveryDate = $(this).data('is-delivery-date');
    if (isDeliveryDate){
      alert('この受注案件の納品日が確定しているため、編集できません。')
      return false;
    }

    // Check if contract end date is empty and billing stop checkbox is checked
    var $contractEndDate = $('input[name*="[contract_end_date]"]');
    var $isPauseCheckbox = $('input[name*="[is_pause]"]:checkbox');

    if ($contractEndDate.length > 0 && $isPauseCheckbox.length > 0 &&
        !$contractEndDate.val() && $isPauseCheckbox.is(':checked')) {
      // Show confirmation dialog
      if (!confirm('契約終了日が入力されていませんが、このまま続けてもよろしいですか。')) {
        // User clicked キャンセル (Cancel) - prevent form submission
        event.preventDefault();
        return false;
      }
      // User clicked はい (Yes) - allow form to submit normally
    }
  });

  $(".js-position").each(function (index) {
    $(this).val(index);
  });

  $(document).on('change', '.estimate-ordered-item-company-id', function() {
    var input_name = $(this).attr('name').split('[').slice(0, 3).join('[');
    var selectedCompanies = $(this).val() || [];
    var orderDetailsTable = $(this).closest('.ordered-item-area').find('.order-details-table');
    var orderDetailsBody = $(this).closest('.ordered-item-area').find('.order-details-body');

    if (selectedCompanies.length === 0) {
        orderDetailsTable.addClass('hidden');

        orderDetailsBody.find('tr').each(function() {
            var nestedIndex = $(this).find('input[name*="[company_id]"]').attr('name').match(/\[(\d+)\]/g)[1].replace(/\D/g, '');
            if (!$(this).find('input[name*="[_destroy]"]').length) {
                $(this).append('<input type="hidden" name="' + input_name + '[estimate_ordered_item_companies_attributes][' + nestedIndex + '][_destroy]" value="true">');
            }
            $(this).addClass('hidden');
        });

        sum_cost_price($(this));
        orderedItemCalcTotal();
        return;
    }

    orderDetailsTable.removeClass('hidden');

    orderDetailsBody.find('tr').each(function() {
        var companyId = $(this).find('input[name*="[company_id]"]').val();
        var nestedIndex = $(this).find('input[name*="[company_id]"]').attr('name').match(/\[(\d+)\]/g)[1].replace(/\D/g, '');
        if (!selectedCompanies.includes(companyId)) {
            if (!$(this).find('input[name*="[_destroy]"]').length) {
                $(this).append('<input type="hidden" name="' + input_name + '[estimate_ordered_item_companies_attributes][' + nestedIndex + '][_destroy]" value="true">');
            }
            $(this).addClass('hidden');
        } else {
            $(this).removeClass('hidden');
        }
    });

    $(this).find("option:selected").each(function () {
        var companyName = $(this).text();
        var companyId = $(this).val();
        var currentTimeMillis = new Date().getTime();

        if (orderDetailsBody.find('input[value="' + companyId + '"]').length === 0 && companyName !== '') {
            var row = `
              <tr id="company_id_${companyId}">
                <td>${companyName}</td>
                <td><input type="hidden" name="${input_name}[estimate_ordered_item_companies_attributes][${currentTimeMillis}][company_id]" value="${companyId}">
                  <input type="text" name="${input_name}[estimate_ordered_item_companies_attributes][${currentTimeMillis}][quantity]" class="convert-half-width form-control text-right amount-pro-ordered price-partner input_decimal"></td>
                <td><input type="text" name="${input_name}[estimate_ordered_item_companies_attributes][${currentTimeMillis}][price]" class="convert-half-width form-control text-right price-pro-ordered price-partner input_decimal"></td>
              </tr>
            `;
            orderDetailsBody.append(row);
            orderDetailsBody.find(`#company_id_${companyId} .input_decimal`).inputFilterx(function(value) {
                return /^[0-9０-９]{0,8}(([.．。][0-9０-９]{0,2})?)$/.test(value.replace(/,/g, ''));
            }, "整数部分は最大8桁、小数部分は最大2桁です。");
        }
    });

    sum_cost_price($(this));
    orderedItemCalcTotal();
});

  $('.ordered-upload').change(e => {
    $(e.target).closest('.upload-documents').find('.upload-item').remove();
    const length = e.target.files.length;
    let size = $(e.target).closest('.upload-list').children('.upload-item').length;
    for (let i = 0; i < length; i++) {
      const name = e.target.files[i].name;
      const temp = "<div class='upload-item'><span class='index'>" + (++size) + ". </span> <span class='file-name'>" + name + "</span>" +
          "<div class='btn-upload-item ordered-btn-delete-file'>" +
          "<img src='/assets/icon/Delete.svg' alt=''/>" +
          "</div>" +
        "</div>";
      $(e.target).closest('.upload-documents').find('.upload-list').append(temp);
    }

    $(document).on('click', '.ordered-btn-delete-file', function(e) {
      $(this).closest('.upload-item').remove();
    });
  });

  $(document).on('change', '.price-partner', function() {
    sum_cost_price($(this));
  })

  function sum_cost_price(ele) {
    var total_price = 0;
    var has_value = false;
    var total_quantity = 0;
    var $row = ele.closest('.nested-fields');
    $row.find('tr:not(.hidden)').find('.price-pro-ordered').each(function() {
      if($(this).val() != '') {
        has_value = true;
      }
      var value = parseFloat($(this).val().replace(/,/g, '')) || 0;
      var amount = parseFloat($(this).closest('tr').find('.amount-pro-ordered').val().replace(/,/g, '')) || 0;
      total_quantity += amount;
      total_price += value * amount;
    });
    const isSegmentCostPrice = $row.find('.js-cost-price').hasClass('segment-cost-price')

    if (isSegmentCostPrice) return;

    if(has_value) {
      var value_string = (total_price/total_quantity).toFixed(2);
      if(isNaN(value_string)) {
        ele.closest('.nested-fields').find('.js-cost-price').val(0);
      } else {
        ele.closest('.nested-fields').find('.js-cost-price').val(Number(value_string).toLocaleString('en-US') || 0);
      }
    } else {
      ele.closest('.nested-fields').find('.js-cost-price').val(0);
    }
  }

  $(document).on('change', '.checked-ordered', function() {
    const $row = $(this).closest('.nested-fields')
    const $elmCostPrice = $row.find('.js-cost-price')
    const isSegmentCostPrice = $elmCostPrice.hasClass('segment-cost-price')

    if (isSegmentCostPrice) return;

    if($(this).is(':checked')) {
      $('#old-cost-price').val($(this).closest('.nested-fields').find('.js-cost-price').val());
      $(this).closest('.nested-fields').find('.js-cost-price').attr('readonly', true).addClass('bg-gray');
      sum_cost_price($(this));
    } else {
      $(this).closest('.nested-fields').find('.js-cost-price').attr('readonly', false).val($('#old-cost-price').val()).removeClass('bg-gray');
    }
  })

  $(document).on('change', '.checked-ordered', function(){
    let $row = $(this).closest(".nested-fields");
    let isChecked = $(this).prop('checked');
    toggleOrderedContainer(isChecked, $row)
  });

  function toggleOrderedContainer(isChecked, $row) {
   if(isChecked){
      $row.find(".ordered-container").removeClass("hidden");
    } else {
      $row.find(".ordered-container").addClass("hidden");
      var $companySelect = $row.find(".estimate-ordered-item-company-id");
      if ($companySelect.length > 0) {
        $companySelect.val([]).trigger('change');
      }
    }
  }

  $(document).on('click', '.js-cancel-choose-order', function() {
    $('.toggle-check-all-object').prop('checked', false);
    $('.checkbox-estimate-item').prop('checked', false);
  })

  function calcDiscountOrdered() {
    var totalDiscount = _.toNumber($('#ordered_total_discount').val()) || 0;
    $.each($('#form-special-discount').find('.discount-fields'), function (idx, $elm) {
      var specialDiscount = _.toNumber(parseInt($($elm).find('.js-special-discount').val().replace(/,/g, ''), 10)) || 0;
      totalDiscount += specialDiscount;
    });
    let discount_value = '';
    $(".form-estimate-sheet .estimate-item-fields").filter(":visible").each(function (idx, $parent) {
      const discountElement = $($parent).find(".ordered_item_estimate_ordered_items_discount input");
      discount_value = (discountElement.val() != '' && discountElement.val() != undefined) ? discountElement.val().replace(/,/g, '') : 0;
      let discount = _.toNumber(parseInt(discount_value));
      totalDiscount += discount;
    });

    $('#ordered_total_discount').val('￥ ' + totalDiscount.toLocaleString('en-US'));
  }

  $(document).on('change', '.ordered_item_ordered_discounts_amount #js-special-discount, .ordered-item-page input, .level-select', function(){
    calcDiscountOrdered()
    orderedItemCalcTotal()
  })

  // $(document).on('change', '.esimate-sheet-page input', function () {
  //   orderedItemCalcTotal(false)
  // })

  orderedItemCalcTotal();

  function orderedItemCalcTotal(isNewPage = false) {
    const marginNumber = _.defaultTo(_.toNumber($('.margin-number-temp').val()), _.toNumber($('#margin-number-temp').val()));
    let totalSellPrice = 0;
    let totalCost = 0;
    let totalAllDiscount = 0;
    let totalAllDiscountFreeTax = 0;
    let totalGrossProfit = 0;
    let summaryTotal = 0;
    let freeTaxTotal = 0;
    let taxIncluded = 0;
    let totalSellPriceChecked = 0;
    let totalSellPriceUnchecked = 0;

    let totalOrderValue = calculateOrderTotal();


    const processItem = ($elm, isSellPrice = true) => {
        const getNumericValue = ($el) => {
            const value = $el.val();
            if (value !== undefined) {
                return _.toNumber(value.replace(/,/g, '')) || 0;
            }
            return 0;
        };

        const costPrice = getNumericValue($($elm).find('.js-cost-price'));
        const amount = getNumericValue($($elm).find('.js-amount'));
        const priceDOM = $($elm).find('.js-price');
        let price = !isNewPage ? getNumericValue(priceDOM) : _.toNumber((marginNumber * costPrice).toFixed(2));

        if (isNewPage) {
            priceDOM.val(price).change();
        }

        const discount = getNumericValue($($elm).find('.js-discount'));
        totalAllDiscount += discount;
        calculateOrderItem($elm)
        const sellPrice = getNumericValue(
          $($elm)
            .find('.sell-price')
            .filter(function () {
              const level = $(this).closest('.estimate-item-fields').find('.level-select').val();
              return !level || level.toLowerCase() === 'nil';
            })
        );

        if ($($elm).find('.js-is_freetax').is(':checked')) {
            freeTaxTotal += sellPrice;
            totalSellPriceChecked += sellPrice;
            totalAllDiscountFreeTax += discount;
        }else{
          totalSellPriceUnchecked += sellPrice;
        }

        if (isSellPrice) {
            totalSellPrice += sellPrice;
        } else {
            totalCost += sellPrice;
        }
        totalGrossProfit += (price - costPrice) * amount;

        return { price, sellPrice, discount };
    };
    $('#form-estimate-nested-sell-price .estimate-item-fields:not(:hidden)').each(function (idx, $elm) {
      processItem($elm);
    });

    // Process all cost items
    $('#form-estimate-nested-cost .estimate-item-fields:not(:hidden)').each(function (idx, $elm) {
        processItem($elm, false);
    });
    // Process special discounts
    let totalSpecialDiscount = 0;
    $('#form-special-discount .discount-fields').each(function (idx, $elm) {
        totalSpecialDiscount += _.toNumber($($elm).find('.js-special-discount').val().replace(/,/g, '')) || 0;
    });
    totalAllDiscount += totalSpecialDiscount;

    // Calculate and update totals
    const tax = 0.1;
    summaryTotal = totalCost + totalSellPrice - totalAllDiscount;

    let totalGrossProfitSegmented = totalSellPrice - totalOrderValue - totalAllDiscount
    totalGrossProfit = totalGrossProfit - totalAllDiscount;
    const totalWithTax = totalCost + totalSellPrice - freeTaxTotal - totalAllDiscount + totalAllDiscountFreeTax;
    const totalTax = totalWithTax <= 0 ? 0 : Math.round(totalWithTax * tax);

    if(totalSellPriceChecked == 0){
      taxIncluded = (totalSellPriceUnchecked  - totalAllDiscount ) * 1.1
    }else if(totalSellPriceUnchecked == 0){
      taxIncluded = totalSellPriceChecked  - totalAllDiscount
    }else{
      taxIncluded = ((totalSellPriceUnchecked - totalAllDiscount) * 1.1 ) + totalSellPriceChecked
    }

    setTimeout(function(){
      $('#total-sell-price-ordered').html('￥ ' + totalSellPrice.toLocaleString('en-US'));
      $('#total-cost-price-ordered').html('￥ ' + Math.round(totalCost).toLocaleString('en-US'));
      $('#total-all-discount-ordered').html('￥ ' + totalAllDiscount.toLocaleString('en-US'));
      $('#total-gross-profit-ordered').html('￥ ' + Math.round(totalGrossProfitSegmented).toLocaleString('en-US'));
      $('#normal-total-gross-profit-ordered').html('￥ ' + Math.round(totalGrossProfit).toLocaleString('en-US'));
      $('#summary-total-ordered').html('￥ ' + Math.round(summaryTotal).toLocaleString('en-US'));
      $('#total-order-price-ordered-item').html('￥ ' + totalOrderValue.toLocaleString('en-US'));
      // if($('#total-summary-tax').length > 0) {
      //   $('#total-summary-tax').html('￥ ' + Math.round(summaryTotal * 1.1).toLocaleString('en-US'))
      //   $('#total-summary-tax').data('value', Math.round(summaryTotal * 1.1));
      //   // let lease_value = $('#monthly_amount').data('value') || 0;
      //   let lease_value = _.toNumber($('#total-lease-price').data('value').toString().replace(/,/g, '')) || 0;
      //   if(lease_value > 0) {
      //     $('#normal-total-gross-profit').html('￥ ' + Math.round(totalGrossProfit - lease_valuet).toLocaleString('en-US'));
      //   }
      //   $('#total_tax_with_lease').html('￥ ' + Math.round(summaryTotal * 1.1 + _.toNumber($('#total-lease-price').data('value').toString().replace(/,/g, ''))).toLocaleString('en-US'))
      // }
      $('#tax-included-ordered').html('￥ ' + Math.round(taxIncluded).toLocaleString('en-US'));
      $('.tax-included-ordered').val(Math.round(taxIncluded))
    }, 100)


    calcDiscountOrdered();
  }

  $(document).on('click', '#ordered_confirm_calc', function () {
    var marginNumber = _.toNumber($('.margin-number-temp').val()) || 0;
    const id = $('.ordered-item-page')[0].getAttribute('data-esti-sheet-id');
    if (id) {
      $.ajax({
        method: 'PUT',
        url: `/ordered_items/${id}/update_margin_number`,
        data: { margin_number: marginNumber },
      });
    }
    orderedItemCalcTotal(true);
  });

  $('.delivery_date').daterangepicker({
    locale: ja_date_locale,
    singleDatePicker: true,
    autoUpdateInput: false,
    autoApply: true,
  });

  $('.delivery_date').on('apply.daterangepicker', function (ev, picker) {
    let format = $(this).data('format') || 'YYYY/MM/DD';
    var data = picker.startDate.format(format);
    var ordered_id = $(this).data('ordered-id');

    $.ajax({
      method: 'put',
      url: `/ordered_items/${ordered_id}/change_delivery_date`,
      data: { delivery_date: data },
      success: function(res) {
        if (res.status) {
          $(`#ordered-item-${ordered_id}`).html(`${data}`);
          $(`#rm-ordered-item-${ordered_id}`).removeClass('hidden');
        } else {
          alert(res.message)
        }
      }
    })
  });

  $(document).on('click', '.remove-delivery-ordered', function() {
    var ordered_item_id = $(this).data('ordered-item-id');

    $.ajax({
      method: 'put',
      url: `/ordered_items/${ordered_item_id}/change_delivery_date`,
      data: { delivery_date: null },
      success: function(res) {
        if (res.status) {
          $(`#ordered-item-${ordered_item_id}`).html('');
          $(`#rm-ordered-item-${ordered_item_id}`).addClass('hidden');
        } else {
          alert(res.message)
        }
      }
    })
  })

  $('.work_completion_date').daterangepicker({
    locale: ja_date_locale,
    singleDatePicker: true,
    autoUpdateInput: false,
    autoApply: true,
  });

  $('.work_completion_date').on('apply.daterangepicker', function (ev, picker) {
    let format = $(this).data('format') || 'YYYY/MM/DD';
    var data = picker.startDate.format(format);
    var ordered_id = $(this).data('ordered-id');

    $.ajax({
      method: 'put',
      url: `/ordered_items/${ordered_id}/change_work_completion_date`,
      data: { work_completion_date: data },
      success: function(res) {
        if (res.status) {
          $(`#work-completion-item-${ordered_id}`).html(`${data}`);
          $(`#rm-work-completion-item-${ordered_id}`).removeClass('hidden');
        } else {
          alert(res.message)
        }
      }
    })
  });

  $(document).on('click', '.remove-work-completion-ordered', function() {
    var ordered_item_id = $(this).data('ordered-item-id');

    $.ajax({
      method: 'put',
      url: `/ordered_items/${ordered_item_id}/change_work_completion_date`,
      data: { work_completion_date: null },
      success: function(res) {
        if (res.status) {
          $(`#work-completion-item-${ordered_item_id}`).html('');
          $(`#rm-work-completion-item-${ordered_item_id}`).addClass('hidden');
        } else {
          alert(res.message)
        }
      }
    })
  })


  $(document).on('click', '.btn-open-search-product-ordered', function (evt) {
    // $('.select-search-product').val('').trigger('change');
    $('.select-search-product').val('')
    $('.select-search-category').val('')
    var nameSearching = $(evt.target).closest('div').find('.js-product-text').val()
    $('#modal-search-product-ordered #q_companies_name_cont').val('');
    $('#modal-search-product-ordered #q_name_cont').val('');
    $('#modal-search-product-ordered #q_price_gteq').val('');
    $('#modal-search-product-ordered #q_price_lteq').val('');
    $('#modal-search-product-ordered .select2').select2({
      theme: 'bootstrap',
      allowClear: true,
      dropdownParent: $('#modal-search-product-ordered'),
      language: {
        noResults: function () {
          return '見つかりません。';
        },
      },

    })
    // $('#modal-search-product-ordered #q_name_cont').val(nameSearching);
    $('.btn-submit.search-product').trigger('click');
    var nestedField = $(evt.target).closest('.nested-fields');
    var insertingSelector = nestedField.length > 0 ? { type: 'orderedItem', value: $(evt.target).closest('.nested-fields') } : { type: 'acceptingOrder', value: $(evt.target).closest('form').attr('id') }
    window.insertingSelector = insertingSelector
    $('#modal-search-product-ordered').modal('show');
  });

  function getSelector() {
    var selector = window.insertingSelector
    if (selector.type == 'acceptingOrder') {
      return $('#' + selector.value);
    } else if (selector.type == 'orderedItem' || selector.type == 'estimateSheet') {
      return selector.value;
    }
  }

  $(document).on('click', '.btn-choose-product-ordered', function (evt) {
    var productId = $(this).attr('value');
    var $container = getSelector();
    var product_type = $(this).attr("product_type");

    $container.find('.js-product-id').attr("product_type", product_type);

    var productId = $(this).val();
    var $estimateItem = $(this).closest('.ordered-item-fields');

    if (productId) {
      $.ajax({
        url: `/products/${productId}/load_data`,
        method: 'GET',
        success: function (res) {
          var $container = getSelector();
          var product = res.product;
          var defaultCost = product.price_second;
          if (defaultCost == null || String(defaultCost).trim() === '') {
            defaultCost = product.price_first;
          }
          if (defaultCost == null || String(defaultCost).trim() === '') {
            defaultCost = 0;
          }
          var cost = formatNumberToCurrency(defaultCost);
          var price = formatNumberToCurrency(product.unit_price) || 0;
          var product_text = product.estimate_name;
          var category = res.category;

          if (window.insertingSelector.type == 'acceptingOrder') {
            $container.find('.js-cost-price').val(cost.toLocaleString('en-US'));
            $container.find('.js-unit').val(price.toLocaleString('en-US'));
          } else {
            $container.find('.js-cost-price').val(cost.toLocaleString('en-US'));
            $container.find('.js-cost-price-text').html(`￥ ${cost.toLocaleString('en-US')}`);
            $container.find('.js-unit-price-text').html(`￥ ${price.toLocaleString('en-US')}`);
            $container.find('.js-price').val(price.toLocaleString('en-US'));
            $container.find('.js-unit-price').val(price.toLocaleString('en-US'));
            var stockAmount = product.stock ? product.stock.amount : 0;
            $estimateItem.find('.js-amount-stock').text(stockAmount.toLocaleString('en-US'));
          }
          $container.find('.js-product-id').val(productId);
          $container.find('.category-product').html(category);
          $container.find('.js-product-text').val(product_text)
          $container.find('.product-name').html(product_text)
          $container.find('.js-is_freetax').attr('checked', product.is_freetax);
          let ordered_item_quantity = parseFloat($('#ordered_item_quantity').val().replaceAll(/,/g, ''), 10) || 0
          let ordered_item_unit_price = parseFloat($('#ordered_item_unit_price').val().replaceAll(/,/g, ''), 10) || 0;
          let total = Math.round(ordered_item_quantity * ordered_item_unit_price) || 0;
          $container.find('.js-selling-price').html(`￥ ${total.toLocaleString('en-US')}`);
        },
      });
    }
    $('#modal-search-product-ordered').modal('hide');
  });

  window.orderedItemCalcTotal = orderedItemCalcTotal

  $(document).on("click", ".js-add-est-ordered-item-bottom", function () {
    setTimeout(function () {
      let lastPosition = Math.max(...$(".js-position").map(function () {
        return parseInt($(this).val()) || 0;
      }).get());

      $(".nested-fields").last().find(".js-position").val(lastPosition + 1);
    }, 100);
  });

  function calculateOrderTotal() {
    let total = 0;
    $('.estimate-item-fields:visible').each(function() {
      $(this).find('.ordered-container:not(.hidden) .order-details-body tr:not(.hidden)').each(function() {
        let quantity = parseFloat($(this).find('.amount-pro-ordered').val()?.replace(/,/g, '')) || 0;
        let price = parseFloat($(this).find('.price-pro-ordered').val()?.replace(/,/g, '')) || 0;
        total += quantity * price;
      });
    });

    return Math.round(total);
  }

  function calculateOrderItem($elm) {

    const $row = $($elm).closest('.estimate-item-fields');
    let total = 0;

    $row.find('.ordered-container:not(.hidden) .order-details-body tr:not(.hidden)').each(function() {
      let quantity = parseFloat($(this).find('.amount-pro-ordered').val()?.replace(/,/g, '')) || 0;
      let price = parseFloat($(this).find('.price-pro-ordered').val()?.replace(/,/g, '')) || 0;
      total += quantity * price;
    });
    setTimeout(function () {
      $row.find('.js-purchase-amount-ordered').val(Math.round(total).toLocaleString('en-US'));
    }, 100)
  }

  $(document).on("click", ".js-add-est-ordered-item-top", function () {
    setTimeout(function () {
      $(".estimate-item-fields").each(function (index) {
        $(this).find(".js-position").val(index);
      });
    }, 100);
  });

  $(document).on('click','.btn-choose-execution-ordered', function () {
        const executionTemplateId = $(this).data('ex-template-id');
        var $container = getSelector();

        Swal.fire({
          title: "処理...",
          text: "しばらくお待ちください",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        $.ajax({
          url: `/execution_templates/${executionTemplateId}/load_data`,
          type: "GET",
          dataType: "json",
          success: function (response) {
            if (response.status !== "success" || !response.data) {
              showDialogError(response.message || "受信したデータは無効です。もう一度試してください。");
              Swal.close();
              return;
            }

            let execution_template_items;
            try {
              execution_template_items = JSON.parse(response.data);
            } catch (e) {
              showDialogError("受信したデータは無効です。もう一度試してください。");
              Swal.close();
              return;
            }

            if (!execution_template_items) {
              showDialogError("受信したデータは無効です。もう一度試してください。");
              Swal.close();
              return;
            }
            let execution_template_items_length = execution_template_items.length;
            let elements = $container.add(
              $container.nextAll('.nested-fields:visible').slice(0, execution_template_items_length - 1)
            );

            setTimeout(() => {
              handleImportExecutionTemplate(elements, execution_template_items);
              Swal.close();
              showDialogSuccess(response.message);
            }, 200);
          },
          error: function (xhr) {
            let errorMessage = "データ入力に失敗しました。もう一度お試しください。";

            if (xhr.responseJSON && xhr.responseJSON.message) {
              errorMessage = xhr.responseJSON.message;
            }

            showDialogError(errorMessage);
            Swal.close();

          }
        });
        $('#modal-search-product').modal('hide');
  });

  function handleImportExecutionTemplate(nestedFields, executionTemplateItems) {
    let $firstRow = nestedFields.first();
    let missingRows = executionTemplateItems.length - nestedFields.length;

    if (missingRows > 0) {
      let $lastRow = $firstRow;
      _.times(missingRows, () => {
        $lastRow = addNewNestedField($lastRow);
      });

      let updatedNestedFields = $firstRow.add(
        $firstRow.nextAll('.nested-fields:visible').slice(0, executionTemplateItems.length - 1)
      );

      updateValueRows(updatedNestedFields, executionTemplateItems);
    } else {
      updateValueRows(nestedFields, executionTemplateItems);
    }
  }

  function updateValueRows(nestedFields, executionTemplateItems) {
    let updatedElements = $();
    nestedFields.each(function (index) {
      let $row = $(this);
      let data = executionTemplateItems[index];

      if (data) {
        let values = {
          '.level-select': data.level,
          '.js-product-text': data.name || data.product_lable,
          '.js-amount': data.amount,
          '.js-unit': data.unit,
          '.js-price': data.price,
          '.sell-price': data.sell_price
        };

        let inputs = Object.keys(values).map(selector => [$row.find(selector), selector]);

        inputs.forEach(([$input, selector]) => {
          if ($input.length) {
            $input.val(values[selector]);
            updatedElements = updatedElements.add($input);
          }
        });
      }
    });
    updatedElements.trigger("change");
  }


  $(document).on("click", ".btn-add-est-ordered-item", function () {
    let $currentRow = $(this).closest(".estimate-item-fields");
    addNewNestedField($currentRow)
  });

  function addNewNestedField($currentRow) {
    let currentTime = Date.now();
    $currentRow.find("select.select2").select2("destroy");

    let maxId = 0;
    $(".estimate-item-fields").each(function () {
        let id = $(this).attr("id").match(/\d+$/);
        if (id && parseInt(id[0]) > maxId) {
            maxId = parseInt(id[0]);
        }
    });

    let newId = "estimate-item-" + (maxId + 1);

    let $newRow = $currentRow.clone(true);
    $newRow.attr("id", newId);
    $newRow.find(".js-is_freetax, .est-checked-ordered").prop("checked", false);
    $newRow.find(".input-field").prop("disabled", false);
    $newRow.find(".level-select, .js-amount, .js-unit, .js-price, .js-product-text").not(".js-sell_price").val("");
    $newRow.find(".js-sell_price, .js-purchase-amount-ordered").val(0);
    $newRow.find(".ordered-container").addClass("hidden");
    $newRow.find(".parent-fields").css('background-color', '#fff');

    $newRow.find("select.select2").each(function () {
      $(this).removeAttr("data-select2-id");
      $(this).removeAttr("aria-hidden");
      let newId = $(this).attr("id") + "_" + currentTime;
      $(this).attr("id", newId);
    });
    $newRow.find("select.select2").val([]).trigger("change");
    $newRow.find('.order-details-body').empty();
    $newRow.find("input, select").each(function () {
      let timestamp = currentTime;
      let name = $(this).attr("name");
                  if (name) {
          name = name.replace(/\[estimate_ordered_items_attributes\]\[\d+\]/, "[estimate_ordered_items_attributes][" + timestamp + "]");
          $(this).attr("name", name);
      }
    });

    $currentRow.after($newRow);
    handleEstCheckedOrdered($currentRow, $newRow)

    $(".estimate-item-fields").each(function (index) {
        $(this).find(".js-position").val(index);
    });
    $("select.select2").select2({theme: "bootstrap",placeholder: "選択してください"});

    return $newRow;

   }

  //logic checkbox

  function handleEstCheckedOrdered($currentRow, $newRow) {
    const $currentCheckbox = $currentRow.find('.est-checked-ordered');
    const currentLevel = parseInt($currentRow.find('.level-select').val(), 10);
    const newLevel = $newRow.find('.level-select').val();
    const isDisabled = $currentCheckbox.prop('disabled');
    const isChecked = $currentCheckbox.prop('checked');
    const $newCheckbox = $newRow.find('.est-checked-ordered');
    let tempLevel = (newLevel == '') ? processTempLevelForBlank($newRow) : newLevel;

    if (currentLevel) {
      const disableNew = isChecked || checkLevelItems($currentRow, currentLevel, 'parent') || checkLevelItems($newRow, tempLevel, 'children');
      $newCheckbox.prop('disabled', disableNew);
    } else {
      $newCheckbox.prop('disabled', isDisabled);
    }
  }



  function getGroupCheckbox($row) {
    let groupRows = [$row];
    let rowLevel = parseInt($row.find(".level-select").val(), 10)

    if (rowLevel !== 1) {
      $row.prevAll(".nested-fields:visible").each(function () {
          let level = parseInt($(this).find(".level-select").val(), 10);
          groupRows.unshift($(this));
          if (level === 1) return false;
      });
    }
    $row.nextAll(".nested-fields:visible").each(function () {
        let level = parseInt($(this).find(".level-select").val(), 10);

        if (level === 1) return false;

        groupRows.push($(this));
    });

    return $(groupRows);
  }

  function processTempLevelForBlank($row) {
    let tempLevel = '';
    $row.prevAll('.nested-fields').each(function () {
        let level = $(this).find('.level-select').val();
        if (level != '') {
            tempLevel = parseInt(level, 10) + 1;
            return false;
        }
    });

    return tempLevel;
  }

  function checkLevelItems($row, level, type = 'same') {
    let groupRows = getGroupCheckbox($row);
    let result = [];

    groupRows.each(function () {
        let $currentRow = $(this);
        if ($currentRow.is($row)) return;

        let currentLevel = $currentRow.find('.level-select').val();
        let isChecked = $currentRow.find('.est-checked-ordered').prop('checked');
        let tempLevel = (currentLevel === '') ? processTempLevelForBlank($currentRow) : parseInt(currentLevel, 10);

        if (isChecked) {
            if (type === 'same' && level == tempLevel) {
                result.push($currentRow);
            } else if (type === 'children' && level < tempLevel) {
                result.push($currentRow);
            }else if (type === 'parent' && level > tempLevel) {
              result.push($currentRow);
          }
        }
    });

    return result.length > 0;
  }

  $(document).on('cocoon:after-insert', function(event, insertedItem) {
    const $newRow = $(insertedItem);
    const newTempLevel = processTempLevelForBlank($newRow);

    let isParentChecked = checkLevelItems($newRow, newTempLevel, 'parent');

    $newRow.find('.est-checked-ordered').prop('disabled', isParentChecked)
    $newRow.find('.js-is-disabled-order').val(isParentChecked)
  });

});
